import { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import './App.css';

// Route-level code splitting — these bundles only download when the user visits that route
const Gallery     = lazy(() => import('./pages/Gallery'));
const OurTeam     = lazy(() => import('./pages/OurTeam'));
const AdminPage   = lazy(() => import('./pages/AdminPage'));
const ServicePage = lazy(() => import('./pages/ServicePage'));

const PageShell = ({ children }) => (
  <Suspense fallback={<div style={{ background: '#0C0C0C', minHeight: '100vh' }} />}>
    {children}
  </Suspense>
);

const SQUIRE_BOOKING_URL = 'https://getsquire.com/booking/brands/bro-code-barbershop';

function ContactRedirect() {
  useEffect(() => {
    window.location.replace(SQUIRE_BOOKING_URL);
  }, []);
  return null;
}

function FloatingBookBtn({ url }) {
  const { pathname } = useLocation();
  if (pathname === '/admin') return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="floating-book-btn"
      onClick={() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'squire_click' });
        window.open(url, '_blank');
      }}
    >
      Book Now
    </a>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"        element={<Home />} />
        <Route path="/gallery" element={<PageShell><Gallery /></PageShell>} />
        <Route path="/team"    element={<PageShell><OurTeam /></PageShell>} />
        <Route path="/admin"   element={<PageShell><AdminPage /></PageShell>} />
        <Route path="/contact" element={<ContactRedirect />} />

        {/* SEO service/location subpages — not in main nav, discoverable via search */}
        <Route path="/:slug"               element={<PageShell><ServicePage /></PageShell>} />
      </Routes>

      <FloatingBookBtn url={SQUIRE_BOOKING_URL} />
    </BrowserRouter>
  );
}

export default App;